import { render, staticRenderFns } from "./messaggio_chat_desktop.vue?vue&type=template&id=1831124e&scoped=true&"
import script from "./messaggio_chat_desktop.vue?vue&type=script&lang=js&"
export * from "./messaggio_chat_desktop.vue?vue&type=script&lang=js&"
import style0 from "./messaggio_chat_desktop.vue?vue&type=style&index=0&id=1831124e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1831124e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCol,VRow})
